export const STORE_USER = 'STORE_USER';
export const USER_SIGNED_OUT = 'USER_SIGNED_OUT';
export const USER_EXPIRED = 'USER_EXPIRED';
export const STORE_USER_ERROR = 'STORE_USER_ERROR';
export const LOADING_USER = 'LOADING_USER';

export const USER_ACTIVITY = 'USER_ACTIVITY';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const STORE_USER_LANGUAGE = 'STORE_USER_LANGUAGE';
export const STORE_TRANSLATIONS = 'STORE_TRANSLATIONS';
